import { createFeatureSelector, createSelector } from '@ngrx/store';
import { COMPARE_PRODUCTS_FEATURE_KEY, CompareProductState } from './compare-products.reducer';

export const getCompareProductState = createFeatureSelector<CompareProductState>(COMPARE_PRODUCTS_FEATURE_KEY);

// eslint-disable-next-line
export const getProductsDataForBar = () =>
  createSelector(getCompareProductState, (state: CompareProductState) => state.productsDataForBar);
